import React from "react";
import { CircularProgress, Grid } from "@material-ui/core";

const CenteredSpinner = () => {
    return (
        <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            >
            <Grid item xs={12}>
                <CircularProgress />
            </Grid>
        </Grid>
    );
}

export default CenteredSpinner;